import { render, staticRenderFns } from "./page-preview.vue?vue&type=template&id=046e1ffe&scoped=true"
import script from "./page-preview.vue?vue&type=script&lang=js"
export * from "./page-preview.vue?vue&type=script&lang=js"
import style0 from "./page-preview.vue?vue&type=style&index=0&id=046e1ffe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046e1ffe",
  null
  
)

export default component.exports